/**
 * Validates directory name when a new directory is created.
 */
export const validateDirectoryName = (directory: string) => {
  if (directory === "") {
    throw new Error("Directory name must be non-empty.");
  }

  const match = directory.match(/^[A-Za-z0-9_-]+$/);
  if (!match) {
    throw new Error('Directory name contains invalid characters (use A-Z, a-z, 0-9, "_", "-").');
  }

  return directory;
};
